export default __webpack_public_path__ + "static/media/mak_cien.063627ca.svg";